// extracted by mini-css-extract-plugin
export default {"rightPanelBox":"rightPanelBox-eIZgS","buttonGroup":"buttonGroup-Wqh3V"};